import LineChart from "../EchartsPage"

const HistoryFlyForms = () => {
    return (
        <div><LineChart /></div>
    )
}

export default HistoryFlyForms